import { createFileRoute } from '@tanstack/react-router';
import { PaymentPage } from '../pages/PaymentPage';
import { ProtectedRoute } from '../../../shared/ui';

// Present when BANKSapi's own top-level bank redirect (e.g. N26 SCA) lands
// back here after a full page reload instead of the in-page widget flow.
type PaymentSearch = {
  sessionId?: string;
};

export const Route = createFileRoute('/payment')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): PaymentSearch => {
    return {
      sessionId: search.sessionId as string,
    };
  },
});

function RouteComponent() {
  const { sessionId } = Route.useSearch();
  return (
    <ProtectedRoute>
      <PaymentPage sessionId={sessionId} />
    </ProtectedRoute>
  );
}
